export default langsData => [{
    path: '/active',
    name: 'active',
    component: () => import(/* webpackChunkName: "active" */ "@/views/active/index.vue"),
    meta: {
        title: langsData['active'].title,
    }
}, {
    path: "/active-detail/:id",
    name: "activeDetail",
    component: () => import(/* webpackChunkName: "active" */ "@/views/active/detail.vue"),
    meta: {
        title: langsData['active'].title,
    },
    props: (route) => ({ id: route.params.id }),
}, {
    path: "/active-pre-detail/:id",
    name: "activePreDetail",
    component: () => import(/* webpackChunkName: "active" */ "@/views/active/predetail.vue"),
    meta: {
        title: langsData['active'].title,
    },
    props: (route) => ({ id: route.params.id }),
},{
    path: '/active/h5',
    name: 'activeH5',
    component: () => import(/* webpackChunkName: "active" */ "@/views/active/h5/index.vue"),
    baseWidth: "360",
    meta: {
        title: langsData['active'].title,
    }
}, {
    path: "/active-detail/h5/:id",
    name: "activeDetailH5",
    component: () => import(/* webpackChunkName: "active" */ "@/views/active/h5/detail.vue"),
    baseWidth: "360",
    meta: {
        title: langsData['active'].title,
    },
    props: (route) => ({ id: route.params.id }),
}, {
    path: "/active-pre-detail/h5/:id",
    name: "activePreDetailH5",
    component: () => import(/* webpackChunkName: "active" */ "@/views/active/h5/predetail.vue"),
    baseWidth: "360",
    meta: {
        title: langsData['active'].title,
    },
    props: (route) => ({ id: route.params.id }),
}]